import { Metrics } from 'web-interactives-dashboard-ui/utils/metricTracker';
import { getInlineEmbedCode } from 'web-interactives-data/api/WebInteractives';
import { FETCH_EMBED_CODE_FAILED, FETCH_EMBED_CODE_STARTED, FETCH_EMBED_CODE_SUCCEEDED } from './ActionTypes';
const fetchEmbedCodeStarted = () => ({
  type: FETCH_EMBED_CODE_STARTED
});
const fetchEmbedCodeSuccess = response => ({
  type: FETCH_EMBED_CODE_SUCCEEDED,
  payload: response
});
const fetchEmbedCodeError = error => ({
  type: FETCH_EMBED_CODE_FAILED,
  payload: error
});
export const fetchEmbedCode = contentId => dispatch => {
  dispatch(fetchEmbedCodeStarted);
  getInlineEmbedCode(contentId).then(response => {
    Metrics.counter('fetch-embed-code-success').increment();
    dispatch(fetchEmbedCodeSuccess(response));
  }).catch(error => {
    Metrics.counter('fetch-embed-code-failed').increment();
    dispatch(fetchEmbedCodeError(error));
  });
};